<script lang="ts">
    import { langField } from "../../../../../i18n"
    import { withImageCacheBuster } from "../../../../../utils"
    import Lasersheets from "../../widgets/lasersheet/Lasersheets.svelte"

    let {
        image,
        idx,
        selectedImgIdx = $bindable(0),
        product,
        shadow,
    }: {
        image: ImageEntry
        idx: number
        selectedImgIdx: number
        product: Product
        shadow?: boolean
    } = $props()

    const hasLasersheets = $derived(!!(product.images?.length && product.lasersheet_configurator?.length))
    const imageLabel = $derived(image.label || langField(product.name) || "Produktbild")
    const ariaLabel = $derived(`Bild ${idx + 1} auswählen: ${imageLabel}`)
</script>

<li class="img-element">
    <button
        class="image-button button transparent"
        class:active={idx === selectedImgIdx}
        aria-pressed={idx === selectedImgIdx}
        onclick={() => (selectedImgIdx = idx)}
        aria-label={ariaLabel}
    >
        <img
            src={withImageCacheBuster(
                image?.file?.src + "?filter=180" + (shadow ? "-shadow" + (hasLasersheets ? "-fixed" : "") : "")
            )}
            alt={imageLabel}
            width="180"
            height="180"
            loading="lazy"
        />
        {#if hasLasersheets}
            <Lasersheets {product} {image} />
        {/if}
    </button>
</li>

<style lang="less">
    @import "../../../../../css/variables.less";
    .img-element {
        height: 158px;
        width: 170px;
        min-width: 170px;
        @media @desktop {
            width: 100%;
            min-width: unset;
        }
        display: flex;
        justify-content: center;
        position: relative;
        overflow: hidden;
        button {
            opacity: 0.5;
            height: 100%;
            transition: ease-in-out 0.2s opacity;
            display: flex;
            justify-content: center;
            width: unset;
            position: relative;
            overflow: hidden;
            &.active {
                opacity: 1;
            }
            :global(img) {
                width: auto;
                height: 100%;
                object-fit: contain;
                position: relative;
            }
            :global(& .lasersheet-container) {
                cursor: pointer;
            }
        }
    }
</style>
